import React from 'react';
import { Container } from 'react-bootstrap';
import { MdDirectionsBus } from 'react-icons/md';
import { tre } from '../trebus';

export default function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer
            style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                width: '100%',
                padding: '1.5rem 0',
                marginTop: 'auto'
            }}
        >
            <Container>
                <div className="d-flex flex-column flex-md-row align-items-center justify-content-between">
                    {/* Logo and brand */}
                    <div className="d-flex align-items-center mb-3 mb-md-0">
                        <div
                            className="d-flex align-items-center justify-content-center rounded-circle me-2"
                            style={{
                                width: '32px',
                                height: '32px',
                                backgroundColor: 'rgba(255,255,255,0.2)'
                            }}
                        >
                            <MdDirectionsBus className="text-white" style={{ fontSize: '18px' }} />
                        </div>
                        <span className="text-white fw-bold" style={{ letterSpacing: '1px' }}>
                            BOLEBUS
                        </span>
                    </div>

                    {/* Copyright */}
                    <div className="text-center text-md-end">
                        <small className="text-white-50">
                            {currentYear} &copy; Bolebus - Sistema de Gestión de Viajes
                        </small>
                        <small
                            className="d-block text-white-50"
                            style={{ fontSize: '0.75rem', marginTop: '2px' }}
                        >
                            {tre.version}
                        </small>
                    </div>
                </div>
            </Container>
        </footer>
    );
}
